const ADJ_MAX_LENGTH = 50;

const truncateDescriptions = sheetAsJson => sheetAsJson.map(({ description, ...batchAdjustment }) => ({
  ...batchAdjustment,
  description: description
    ? description.substring(0, ADJ_MAX_LENGTH)
    : description,
}));

export default truncateDescriptions;
